<hyperkit-typography
  variant="emphasized"
  size="sm"
  align="left"
  color="primary"
  >{{ label }}</hyperkit-typography
>
